import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getVendoreRequestNumbers = async (user, page, page_size, search, status) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/vendor_meta_phone_number/list`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            params: { page, page_size, search, status }
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        console.log(err);

    }
};

export default getVendoreRequestNumbers;
